// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"bdf933cc","216":"cd6e6336","315":"74235039","777":"7e0ccd54","783":"cd180c74","795":"5b393f11"}[chunkId] + ".chunk.js";
};